import { Link } from "wouter";

export function Footer({ variant = "brand" }: { variant?: "brand" | "light" }) {
  const isBrand = variant === "brand";

  return (
    <footer
      data-footer="shared-footer"
      className={
        isBrand
          ? "bg-[#2d5a3d] text-white"
          : "bg-gray-50 border-t text-gray-900"
      }
    >
      <div className="container mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-[1fr_1fr_1.45fr] gap-8 md:gap-12 lg:gap-16 items-start mb-8 md:mb-10">
            <div className="space-y-4">
              <h3 className={`text-lg font-semibold ${isBrand ? "text-white" : ""}`}>
                Liquid Stretch
              </h3>
              <ul className={`space-y-3 text-sm ${isBrand ? "text-white/80" : "text-gray-600"}`}>
                <li>
                  <Link href="/" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Liquid Stretch
                  </Link>
                </li>
                <li>
                  <Link href="/ben-care" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Ben Care
                  </Link>
                </li>
                <li>
                  <Link href="/articles/first-light-to-golden-hour-liquid-stretch" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Formulation Journey
                  </Link>
                </li>
                <li>
                  <Link href="/lab-results" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Lab Results
                  </Link>
                </li>
                <li>
                  <Link href="/legal" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Is This Legal?
                  </Link>
                </li>
                <li>
                  <Link href="/terms" className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}>
                    Terms & Conditions
                  </Link>
                </li>
              </ul>
            </div>

            <div className="space-y-4">
              <h3 className={`text-lg font-semibold ${isBrand ? "text-white" : ""}`}>
                Related Sites
              </h3>
              <ul className={`space-y-3 text-sm ${isBrand ? "text-white/80" : "text-gray-600"}`}>
                <li>
                  <a
                    href="https://enhancedbiofeedback.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}
                  >
                    Enhanced Biofeedback
                  </a>
                </li>
                <li>
                  <a
                    href="https://workoutgummies.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}
                  >
                    Crush by Workout Gummies
                  </a>
                </li>
                <li>
                  <a
                    href="https://laydownnow.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={isBrand ? "hover:text-white underline underline-offset-4" : "hover:underline"}
                  >
                    Lay Down Now
                  </a>
                </li>
              </ul>
            </div>

            <div className={`space-y-4 text-sm ${isBrand ? "text-white/80" : "text-gray-600"}`}>
              <h3 className={`text-lg font-semibold ${isBrand ? "text-white" : ""}`}>
                FDA Disclaimer
              </h3>
              <div className="space-y-3">
                <p className="leading-relaxed">
                  The statements made regarding these products have not been evaluated by the Food and Drug Administration.
                  The efficacy of these products has not been confirmed by FDA-approved research. These products are not
                  intended to diagnose, treat, cure or prevent any disease. All information presented here is not meant as
                  a substitute for or alternative to information from health care practitioners. Please consult your health
                  care professional about potential interactions or other possible complications before using any product.
                </p>
                <p className="leading-relaxed">
                  The intended use of the products is for hemp derived products with THC less than .3%.
                </p>
              </div>
            </div>
          </div>

          <div className={`pt-6 md:pt-8 ${isBrand ? "border-t border-white/20" : "border-t"}`}>
            <div className="text-center">
              <p className={`text-sm ${isBrand ? "text-white/80" : "text-gray-600"}`}>
                (c) {new Date().getFullYear()} Liquid Stretch. All rights reserved. Last updated: April 2026.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
